<template>
    <div>
        <v-card class="pa-5" elevation="0">
            <h2>Traffic</h2>
            <div ref="livetrafficChart" style="width: 100%; height: 400px;"></div>

            <h4 v-if="average" class="avg">
                {{ $store.getters.t('평균 트래픽') }}: {{ average.value }} {{ unitType }} | {{ $store.getters.t('피크 트래픽') }}: {{ average.max }} {{ unitType }} | {{ $store.getters.t('토탈 전송량') }}: {{ average.total }} {{ unitType }}
            </h4>
        </v-card>
    </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
    name: 'WebRTCTraffic',
    data() {
        return {
            chartInstance: null,
        };
    },
    props: ['trafficData', 'unitType', 'average'],
    methods: {
        initChart() {
            const chartDom = this.$refs.livetrafficChart;
            if (chartDom) {
                if (this.chartInstance) {
                    this.chartInstance.dispose();
                }
                this.chartInstance = echarts.init(chartDom);
                this.updateChart();
            } else {
                console.error('Chart DOM not found');
            }
        },
        formatUnixTimestamp(unixTimestamp) {
            const date = new Date(unixTimestamp * 1000);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
        updateChart() {
            if (this.chartInstance && this.trafficData) {
                const data = this.trafficData.map(item => [this.formatUnixTimestamp(item._source.probe_date), item._source.in_byte]);

                const option = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { type: 'cross' }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'time',
                        splitLine: { show: false }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                             formatter: (value) => `${value} ${this.unitType}`
                        }
                    },
                    series: [{
                        name: 'Traffic',
                        type: 'line',
                        data: data,
                        smooth: true,
                        label: { show: false, position: 'top', fontSize: 10 }
                    }]
                };

                this.chartInstance.setOption(option, true);

            } else {
                console.error('traffic instance error');
            }
        },
    },
    watch: {
        trafficData(newData) {
            if (newData && newData.length > 0) {
                this.initChart();
            } else {
                this.chartInstance.dispose();
            }
        },
    },
    beforeDestroy() {
        if (this.chartInstance) {
            this.chartInstance.dispose();
        }
    }
};

</script>

<style scoped>
.primary {
    color: #006cea;
}

.avg {
    width: 94%;
    font-size: 15px;
    font-weight: 550;
    display: flex;
    align-items: center;
    white-space: nowrap;
    margin-top: 3rem;
    color: #006CEA;
}


.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-top: 5px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>